var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { remCalc } from '../styled-components';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  max-width: ", ";\n  margin: 0 0 0 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  max-width: ", ";\n  margin: 0 0 0 0;\n"])), remCalc(648));
export default Form;
var templateObject_1;
